import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Глобальная обработка ошибок JavaScript
window.addEventListener('error', (event) => {
  console.error('Глобальная ошибка JavaScript:', event.error);
  // Подавляем ошибки, связанные с $ (jQuery), чтобы они не ломали приложение
  if (event.error && event.error.message && event.error.message.includes('$ is not defined')) {
    console.warn('Подавлена ошибка jQuery - приложение продолжает работать');
    event.preventDefault();
    return false;
  }
});

// Обработка необработанных Promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Необработанное отклонение Promise:', event.reason);
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
